import { ui } from "@patient-watch/ui";
import { useRouter } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { type RouterWithStores } from "@/lib/router-stores";
import { cn } from "../../lib/utils";
import Spinner from "./Spinner";

/**
 * useRouterState reads router.stores.__store immediately; if stores is not ready
 * yet, that throws. useStore(router?.stores?.__store, …) is safe (see @tanstack/react-store useStore).
 */
export function RouterSpinner() {
    const router = useRouter({ warn: false }) as RouterWithStores;
    const isLoading = useStore(router?.stores?.__store, (s) => s?.status === "pending");
    return (
        <ui.Card
            className={cn(
                "top-[50svh] left-[50vw] z-50 fixed bg-white w-[100px] h-[100px] translate-x-[-50px] translate-y-[-50px]",
                !isLoading && "hidden"
            )}
        >
            <ui.CardContent className="m-auto p-5 w-full h-full">
                <Spinner className="p-1 w-full h-full" />
            </ui.CardContent>
        </ui.Card>
    );
}
